/* export const base_api_url = 'http://localhost:1965';
export const base_new_api_url = 'http://localhost:3600'; */
export const base_api_url = process.env.REACT_APP_API_URL;
export const base_new_api_url = process.env.REACT_APP_API_URL;   
